function AnalysisData() {
    "use strict";
    this.IncidentClean = null;
    this.IncidentSort = null;
    this.IncidentDirty = null;
    this.IncidentPaginated = null;
    this.IncidentMatches = null;
    this.IncidentMatchesPaginated = null;
    this.IncidentMatchesDirty = null;
    this.IncidentMatchesClean = null;
    this.RequestId = -1
    this.SpatialMatchRadius = 2640; //feet
    this.SpatialMatchTitle = '';
    this.SpatialMatchIncident = null;
    this.TempSpatialMatchIncident = null;
    this.SpatialMatchesRawList = null;
    this.SpatialMatchStartDate = null;
    this.SpatialMatchEndDate = null;
    this.SpatialMatchesList = null;
    this.SpatialMatches = null;
    this.EnrolleeSpatialMatches = null;
    this.SpatialMatchesPaginated = null;
    this.SpatialLastLocationByCardView = null;
    this.DeviceIdList = [];

    this.EditItem = null;
    this.PlaybackDivider = 1;

    this.DistancePoints = [];
    this.DistanceToolActive = false;
    this.FilterId = -1;

    //zones
    this.EditShape = null;
    this.ViewShape = null;

    //addresses
    this.AddressCards = null;

    //Enrollee MGAP
    this.EnrolleeMGAPCards = null;
    this.MGAPToggle = false;
    this.AddressesToggle = false;
    this.LabelCountToggle = false;
    this.Tracks = [];

    //SpatialRadius
    this.SpatialRadius = 1500;
}
if (typeof exports !== 'undefined') {
    module.exports = AnalysisData;
}